import React, { useState, useEffect, useCallback } from 'react';
import shouldShowDesktopSiteBanner, { readDismissed, markDismissed } from './shouldShowDesktopSiteBanner';
import styles from './DesktopSiteBanner.module.scss';

// Shown on the customer ordering screens when a touch device is rendering the
// desktop-width layout — the signature of a browser with "Desktop site" enabled.
// See shouldShowDesktopSiteBanner for the detection rationale.
export default function DesktopSiteBanner() {
  const [visible, setVisible] = useState(false);

  const evaluate = useCallback(() => {
    setVisible(shouldShowDesktopSiteBanner({
      maxTouchPoints: navigator.maxTouchPoints || 0,
      hasTouchStart: 'ontouchstart' in window,
      innerWidth: window.innerWidth,
      dismissed: readDismissed(window.sessionStorage),
    }));
  }, []);

  useEffect(() => {
    evaluate();
    window.addEventListener('resize', evaluate);
    window.addEventListener('orientationchange', evaluate);
    return () => {
      window.removeEventListener('resize', evaluate);
      window.removeEventListener('orientationchange', evaluate);
    };
  }, [evaluate]);

  const dismiss = () => {
    markDismissed(window.sessionStorage);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="alert">
      <span className={styles.text}>
        Your browser looks like it&rsquo;s in <strong>Desktop&nbsp;Site</strong> mode. For the best experience
        ordering on your phone, turn off &ldquo;Desktop site&rdquo; in your browser menu, then reload this page.
      </span>
      <button
        type="button"
        className={styles.dismiss}
        aria-label="Dismiss"
        onClick={dismiss}
      >
        &times;
      </button>
    </div>
  );
}
